import type { Conf } from 'src/global';
import {
    CHAT_SELECTOR,
    CHAT_SUB_DIV,
    CHAT_SUBTITLE,
    CHAT_TITLE,
    checkExist,
    disableChat,
    enableChat,
} from 'src/util';

export const changePendoText = (isOnline: boolean, conf: Conf) => {
    const disableListener = (conf: Conf) => {
        const el = document.querySelector(CHAT_SELECTOR);
        el?.removeEventListener('click', () => enableChat(conf));
        el?.addEventListener('click', disableChat);
    };

    const enableListener = (conf: Conf) => {
        const el = document.querySelector(CHAT_SELECTOR);
        el?.removeEventListener('click', disableChat);
        el?.addEventListener('click', () => enableChat(conf));
    };

    const setElText = (selector: string, text: string) => {
        const element = document.querySelector<HTMLElement>(selector);
        if (element !== null) {
            element.innerText = text;
        }
    };

    const setupChatButton = (title: string, subtitle: string) => {
        const el = document.querySelector(CHAT_TITLE);
        if (!el) {
            return null;
        }
        setElText(CHAT_TITLE, title);
        setElText(CHAT_SUBTITLE, subtitle);
    };

    const hourText = () => {
        setupChatButton('Support Hours (Paid User)', 'Available 11am-7pm UTC');
        disableListener(conf);
    };

    const chatText = () => {
        setupChatButton('Chat With Us', 'LIVE CHAT OR LEAVE A MESSAGE, AVAILABLE 11AM-7PM UTC');
        enableListener(conf);
    };

    if (isOnline) {
        chatText();
        checkExist('body', CHAT_SUB_DIV, chatText, conf);
    } else {
        hourText();
        checkExist('body', CHAT_SUB_DIV, hourText, conf);
    }
};

export default changePendoText;
